import { translateKey } from 'src/locales/translate';
import { StockWarningDto } from 'woofwoof-api';
import { formatMilli } from '../utils/quantity';

/** A shortage never blocks the save; the user learns about it here. */
export function notifyStockWarnings(
  enqueue: (message: string, options: { variant: 'warning' }) => unknown,
  warnings: StockWarningDto[],
): void {
  warnings.forEach((warning) =>
    enqueue(
      translateKey('warehouse.common.stockWarning', {
        name: warning.productName,
        quantity: formatMilli(warning.shortfallMilli),
      }),
      { variant: 'warning' },
    ),
  );
}
